import { REVIEW_STATUS } from '@/constants/reviewStatus'
import { INPUTS } from '../_constants/Inputs'
import { COMPANIES_WITH_SPECIFIC_FEATURES, EXPENSE_TYPES } from '../_constants/constants'
import { segmentTrack } from '@/analytics/segment'
export default {
  props: {
    transactionId: {
      type: [Number, String]
    }
  },
  data () {
    return {
      transactionReviewedFlag: false,
      typeSelected: '',
      receiptUploaded: {},
      showConfirmModal: false,
      showCloseWarning: false,
      showUploadInProgress: false,
      warningToIgnore: null,
      receiptToDelete: null,
      resourceId: null,
      dummyPaymentMethod: null,
      inputsOrdered: [],
      options: {},
      ocrTaxOptions: {}
    }
  },
  computed: {
    newExpense () {
      return this.$store.getters['TransactionsStore/newExpense']
    },
    transactionType () {
      return this.transaction.type && this.transaction.type.code
        ? this.transaction.type.code
        : ''
    },
    isPlexus () {
      const { id } = COMPANIES_WITH_SPECIFIC_FEATURES.find(el => el.company === 'PLEXUS')
      return this.$store.getters['CompanyStore/currentCompany'].id === id
    },
    isInMyExpenses () {
      return this.$route.name.includes('expenses')
    },
    isAdmin () {
      return this.$store.getters['LoginStore/isAdmin']
    },
    isBookKeeper () {
      return this.$store.getters['LoginStore/isBookKeeper']
    },
    isRegular () {
      return this.$store.getters['LoginStore/isUser']
    },
    userCanLockTransaction () {
      if (!this.transactionId) return false
      if (this.isAdmin || this.isBookKeeper) return true
      if (this.isRegular && this.userIsOwnerOfBudget) return true
      return false
    },
    userCanRemoveExpense () {
      if (this.transactionId) {
        return this.isExpense && this.transactionUser === this.currentUserId && (this.transaction.reviewStatus.code === 'DRAFT' || this.transaction.reviewStatus.code === REVIEW_STATUS.AWAITING_REVIEW || this.transaction.reviewStatus.code === REVIEW_STATUS.OFFICE_FLOW_REVISION)
      }
      return false
    },
    showSaveAsDraftButton () {
      if (!this.transactionId) {
        return this.isDirty
      } else {
        return this.reviewStatus === 'DRAFT' && this.isDirty
      }
    },
    showSendToReviewButton () {
      if (!this.transactionId) {
        return this.canBeSubmitted
      }
      return this.reviewStatus === 'DRAFT' && this.canBeSubmitted
    },
    showSaveButton () {
      return this.transactionId && this.reviewStatus !== 'DRAFT' ? this.isDirty : false
    },
    currentUserId () {
      // currentUserId in transactionEditModal
      return this.$store.getters['LoginStore/loggedUserId'] || false
    },
    transaction () {
      return this.$store.getters['TransactionsStore/currentTransaction']
      /* const transaction = this.$store.getters['TransactionsStore/currentTransaction']
      return Object.keys(transaction).length > 0 ? transaction : {
        type: {
          code: 'EXPENSE'
        }
      } */
    },
    expenseId () {
      return this.transaction && this.transaction.expense ? this.transaction.expense.id : false
    },
    userIsOwnerOfBudget () {
      return this.transaction && this.transaction.budget
        ? this.transaction.budget.imOwner
        : false
    },
    isUser () {
      return this.$store.getters['LoginStore/isUser']
    },
    userHasDevoluiva () {
      return (
        this.currentUser &&
        this.currentUser.office &&
        this.currentUser.office.customer &&
        this.currentUser.office.customer.isDevoluivaActivated
      )
    },
    currentUser () {
      return this.$store.getters['UsersStore/userLogged']
    },
    transactionUser () {
      return this.transaction && this.transaction.card
        ? this.transaction.card.user.id
        : false
    },
    isExpense () {
      return this.transaction && this.transaction.type
        ? this.transaction.type.code === 'EXPENSE'
        : false
    },
    transactionHasLockedAt () {
      return !!(this.transaction && this.transaction.lockedAt)
    },
    transactionLockedBy () {
      return this.transactionHasLockedAt ? this.transaction.lockedBy : false
    },
    isProcessing () {
      return this.transaction.processing
    },
    transactionIsLocked () {
      return (
        this.transactionHasLockedAt === true ||
        this.transactionHasAccountingPeriodClosed !== null
      )
    },
    transactionWithoutReceipt () {
      return this.transaction?.withoutTicket && (!this.receipts || this.receipts.length === 0)
    },
    transactionWithoutReceiptNotes () {
      return this.transaction?.withoutTicketNotes
    },
    transactionIsLockedIcon () {
      if (this.transactionIsLocked) {
        return this.transactionHasAccountingPeriodClosed !== null
          ? 'icon-agencia-tributaria'
          : 'icon-lock'
      }
      return null
    },
    transactionReviewed () {
      return this.transaction && this.transaction.reviewedAt
    },
    transactionReviewedBy () {
      return this.transactionReviewed ? this.transaction.reviewedBy : false
    },
    transactionHasAccountingPeriodClosed () {
      if (
        this.transaction &&
        this.transaction.receipt &&
        this.transaction.receipt.accountingPeriod
      ) {
        const accountingPeriod = this.transaction.receipt.accountingPeriod
        const name = accountingPeriod.name
        if (!name) {
          const startDate = this.$moment.utc(accountingPeriod.startDate).format(
            'DD/MM/YY'
          )
          const endDate = this.$moment.utc(accountingPeriod.endDate).format(
            'DD/MM/YY'
          )
          return `${startDate} - ${endDate}`
        }
        return name
      }
      return null
    },
    transactionStatusTooltip () {
      if (this.transactionIsProcessing) {
        return this.transactionProcessingTooltipLabel
      } else {
        return this.transactionStatusTooltiReviewStatusLabelTooltip()
      }
    },
    transactionProcessingTooltipLabel () {
      if (this.transactionIsProcessing) {
        return this.$i18n.t('transactions_processing_tooltip_label')
      }
      return ''
    },
    transactionAccounted () {
      return this.transaction?.accountedAt
    },
    transactionAccountedBy () {
      return this.transactionAccounted ? this.transaction?.accountedBy : ''
    },

    transactionReviewedByTooltipLabel () {
      if ((this.isAdmin || this.isBookKeeper) && this.transaction.accountedAt) {
        return this.$i18n.t('transaction_accounted_tooltip_label', [
          this.transactionAccountedBy.firstName,
          this.transactionAccountedBy.lastName,
          this.$moment.utc(this.transactionReviewed).format('DD/MM/YY HH:mm')
        ])
      } else if (this.transactionReviewed && this.transactionReviewedBy) {
        return this.$i18n.t('transaction_review_tooltip_label', [
          this.transactionReviewedBy.firstName,
          this.transactionReviewedBy.lastName,
          this.$moment.utc(this.transactionReviewed).format('DD/MM/YY HH:mm')
        ])
      }
      return ''
    },
    transactionLockedByTooltipLabel () {
      if (this.transactionHasAccountingPeriodClosed) {
        return this.$i18n.t('transaction_lock_accounting_period', [
          this.transactionHasAccountingPeriodClosed
        ])
      }
      if (this.transactionHasLockedAt && this.transactionLockedBy) {
        return this.$i18n.t('transaction_lock_tooltip_label', [
          this.transactionLockedBy.firstName,
          this.transactionLockedBy.lastName,
          this.$moment.utc(this.transaction.lockedAt).format('DD/MM/YY HH:mm')
        ])
      }
      return ''
    },
    isReceiptModalOpen () {
      return this.$store.getters['TransactionsStore/receiptModalIsOpen']
    },
    modalIsOpen () {
      return this.$store.getters['GlobalStore/modalIsOpen']
    },
    paymentMethods () {
      if (this.dummyPaymentMethod?.id) {
        return [this.dummyPaymentMethod, ...this.$store.getters['TransactionsStore/userPaymentMethods']] || []
      }
      return this.$store.getters['TransactionsStore/userPaymentMethods'] || []
    },
    expenseUserId () {
      if (this.transactionId) {
        return this.transaction?.card?.user?.id || 0
      }
      return this.currentUserId
    },
    expensesReceipts () {
      return this.$store.getters['TransactionsStore/currentExpenseReceipts'] || []
    },
    receipts () {
      return this.transaction?.receipt?.receiptMedia ? this.transaction.receipt.receiptMedia : this.expensesReceipts
    },
    transactionIsAccounted () {
      return !!this.transaction.accountedAt
    }
  },
  methods: {
    showTransactionModal (transaction) {
      this.$emit('showTransactionModal', transaction, this.expenseType?.toLowerCase())
    },
    orderInputs () {
      let inputs = this.expenseType === 'EXPENSE' ? INPUTS.expenses : INPUTS.transactions
      inputs.forEach(item => {
        if (!this.fieldIsRequired(item.key) && item.key !== 'mandatoryTagTypes' && item.key !== 'notes') {
          item.weight = item.weight + 50
        } else if (this.fieldIsRequired(item.key) && item.key !== 'mandatoryTagTypes' && item.key !== 'notes') {
          item.weight = item.weight - 50
        }
      })

      inputs.sort(function (a, b) {
        return a.weight - b.weight
      })
      this.inputsOrdered = inputs.map(item => item.key)
    },
    calculateOptions () {
      this.options.amount = this.getOptions('amount')
      this.options.date = this.getOptions('date')
      this.options.provider = this.getOptions('provider')
      this.options.providerData = this.getOptions('providerData')
      this.options.receiptNumber = this.getOptions('receiptNumber')
      this.options.address = this.getOptions('address')
      this.options.zipCode = this.getOptions('zipCode')
      this.options.city = this.getOptions('city')
      this.options.state = this.getOptions('state')
      this.options.country = this.getOptions('country')
      this.options.taxBase1 = this.getOptions('taxBase1')
      this.options.taxBase2 = this.getOptions('taxBase2')
      this.options.taxBase3 = this.getOptions('taxBase3')
      this.options.taxBase4 = this.getOptions('taxBase4')
      this.options.taxBase5 = this.getOptions('taxBase5')
      this.options.taxBase6 = this.getOptions('taxBase6')
    },

    getOptions (property) {
      const options = []
      const receiptOcrs = this.transaction?.receipt?.receiptOcrs?.length > 0 ? this.transaction?.receipt?.receiptOcrs : this.receipt?.receiptOcrs
      const receiptOcrDevoluiva = this.transaction?.receipt?.receiptOcrDevoluiva?.length > 0 ? this.transaction?.receipt?.receiptOcrDevoluiva : this.receipt?.receiptOcrDevoluiva
      if (receiptOcrs) {
        receiptOcrs.forEach((item, index) => {
          if (item[property]) {
            options.push({ number: this.$t('transaction_edit_ocr_receipt', { index: index + 1 }), item: item[property] })
          }
        })
      }
      if (receiptOcrDevoluiva && receiptOcrDevoluiva[property]) {
        options.push({ number: this.$t('DEVOLUIVA_KEY'), item: receiptOcrDevoluiva[property] })
      }
      return options
    },
    async uploadedReceipt (filesLength) {
      const originalTransaction = { ...this.transaction }
      if (originalTransaction.isCompleted !== this.transaction.isCompleted) {
        await this.$store.dispatch('TransactionsStore/fetchTransactionDashboard')
      }
      await this.fetchTransaction()
      this.setIntervalTransaction(this.transaction.id)
      segmentTrack('Transaction ticket added', {
        transaction_id: this.transactionId,
        picture_count: this.transaction.receipt.receiptMedia.length,
        ticket_added: filesLength
      })
    },
    checkCloseModal () {
      if (!this.transactionId && this.showSaveAsDraftButton) {
        this.showCloseWarning = true
      } else {
        this.closeModal()
      }
    },
    uploadingAccept () {
      this.showUploadInProgress = false
      localStorage.setItem('uploadInProgress', true)
    },
    paymentMethodsLabel (paymentMethod) {
      return `${paymentMethod?.officePaymentMethod?.name} - ${paymentMethod?.officePaymentMethod?.repayable ? this.$t('expenses_expense_is_reimbursable') : this.$t('expenses_expense_is_not_reimbursable')}`
    },
    checkPaymentMethodInList () {
      if (this.transaction.id) {
        if (this.transaction.expense.paymentMethod?.id) {
          const paymentMethodDoesNotExist = this.paymentMethods.findIndex(el => el.id === this.transaction.expense.paymentMethod.id) === -1
          if (paymentMethodDoesNotExist) {
            this.dummyPaymentMethod = { ...this.transaction.expense.paymentMethod }
          }
        }
      }
    },
    showIgnoreWarning (warningToIgnore) {
      this.warningToIgnore = warningToIgnore.id
      this.showIgnoreWarningModal = true
    },
    transactionStatusTooltiReviewStatusLabelTooltip () {
      let label = ''
      if (this.transactionAccounted && this.transactionAccountedBy) {
        label += this.$i18n.t('transaction_accounted_tooltip_label', [
          this.transactionAccountedBy?.firstName,
          this.transactionAccountedBy?.lastName,
          this.$moment.utc(this.transactionAccounted).format('DD/MM/YY HH:mm')
        ])
      }
      if (this.transactionReviewed && this.transactionReviewedBy) {
        let reviewedByLabel = this.$i18n.t('transaction_review_tooltip_label', [
          this.transactionReviewedBy.firstName,
          this.transactionReviewedBy.lastName,
          this.$moment.utc(this.transactionReviewed).format('DD/MM/YY HH:mm')
        ])

        if (label) {
          label = label + '<br/>' + reviewedByLabel
        } else {
          label += reviewedByLabel
        }
      }

      return label
    },

    async ignoreWarning () {
      await this.$store.dispatch('TransactionsStore/ignoreTransactionWarning', this.warningToIgnore)
      this.transaction.warnings.forEach(item => {
        if (item.id === this.warningToIgnore) {
          item.ignored = true
        }
      })
      this.$store.getters['TransactionsStore/transactions'].filter(el => {
        if (el.id === this.transaction.id) {
          el.warnings.forEach(item => {
            if (item.id === this.warningToIgnore) {
              item.ignored = true
            }
          })
        }
      })
    },
    dismissWarning () {
      this.warningToIgnore = null
    },
    emitShowReceiptModal ({ transactionId, receiptId }) {
      // emitShowReceiptModal in transactionEdit uses "showReceiptModal" event
      if (transactionId) {
        this.$emit('showReceiptModal', {
          transactionId: transactionId,
          receiptId: receiptId
        })
      } else {
        this.$emit('showReceiptModal', {
          receiptId: receiptId,
          expenseType: this.expenseType
        })
      }
    },
    async handleLockTransaction (event) {
      if (this.transaction.receipt.accountingPeriod === null) {
        await this.$store.dispatch('TransactionsStore/toggleLockTransaction', {
          transactionId: this.transaction.id,
          lock: event
        })
      } else {
        this.$store.dispatch(
          'SnackBars/addError',
          this.$i18n.t('transaction_lock_accounting_period'),
          { root: true }
        )
      }
    },
    async handleReviewTransaction (event) {
      await this.$store.dispatch('TransactionsStore/toggleReviewTransaction', {
        transactionId: this.transactionId,
        review: event
      })
      this.transactionReviewedFlag = event
    },
    async deleteTransaction () {
      this.$emit('confirmDelete', this.transactionId)
    },
    async fetchTransaction () {
      try {
        if (!this.transactionId) return

        this.isGettingTransaction = true

        await this.$store.dispatch(
          'TransactionsStore/fetchTransaction',
          this.transactionId
        )
      } catch (error) {
      } finally {
        this.isGettingTransaction = false
      }
    },
    async setExpenseReceipts (event) {
      const receipts = []

      if (event.length && event.length > 0) {
        const receivedFileList = [...event]
        receivedFileList.forEach((el) => {
          const receiptLocalIdAux = this.receiptLocalId++
          receipts.push({
            id: receiptLocalIdAux,
            file: el,
            media: {
              id: receiptLocalIdAux,
              type: this.typeSelected
            }
          })
        })
      }

      this.$store.dispatch('TransactionsStore/addExpensesReceipts', receipts)
      if (this.expenseType === EXPENSE_TYPES.EXPENSE || this.expenseType === EXPENSE_TYPES.REIMBURSEMENT) {
        await this.createExpense('DRAFT')
      }
      if (!localStorage.getItem('uploadInProgress')) {
        this.showUploadInProgress = true
      }
    },
    async fetchPaymentMethods () {
      const filters = {
        'user.id': this.expenseUserId,
        'officePaymentMethod.rawExpenseTypes': this.expenseType
      }

      await this.$store.dispatch('TransactionsStore/fetchPaymentMethods', filters)
    }
  }
}
